module.exports = __webpack_public_path__ + "img/pay_bank_20.6ba177c9.png";